import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractFormDialog, AbstractDialogResultData } from '@next/core-lib/dialog';

@Component({
  selector: 'app-edit-machining-depth-dialog',
  templateUrl: './edit-machining-depth-dialog.component.html',
  styleUrls: [],
  standalone: false,
})
export class EditMachiningDepthDialogComponent extends AbstractFormDialog<{
  machiningDepthInCentimeters: number;
}> {
  data = inject<Record<string, unknown>>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<
    MatDialogRef<
      EditMachiningDepthDialogComponent,
      AbstractDialogResultData<{
        machiningDepthInCentimeters: number;
      }>
    >
  >(MatDialogRef);
  private readonly fb = inject(FormBuilder);

  formGroup = this.fb.group({
    machiningDepthInCentimeters: [25, [Validators.required, Validators.min(0), Validators.max(30)]],
  });
}
